// src/utils/alertUtils.ts

import useAlertStore from "../zustand/alert";

export const createAlert = ({ title, message, notification, type, status }) => {
  const { createAlert } = useAlertStore.getState(); // Access the Zustand store's alert method

  const fallbackMessage = message || notification?.body || notification?.title || (type === "error" ? "Something went wrong" : "Success");
  const normalizedNotification = {
    title: notification?.title || title || (type === "error" ? "Error" : "Success"),
    body: notification?.body || fallbackMessage,
    titleArabic: notification?.titleArabic || notification?.title || title || (type === "error" ? "خطأ" : "نجاح"),
    bodyArabic: notification?.bodyArabic || notification?.body || fallbackMessage,
  };

  // Call the Zustand store's createAlert method to update the state
  createAlert({
    title,
    message: fallbackMessage,
    notification: normalizedNotification,
    type,
    status,
  });
};
